import '../../../less/afsp.less';
import { Layout, Row, Col, Button, Icon } from 'antd';
import { Container } from '@bit/ui-common.ui-components/ss-components';
import { Link } from 'react-router-dom';
import { config, getContentStyle } from '../../../utils/components/afspLayout';
import { cwrite } from '../../../utils/errorUtils';
import SessionServices from '../../../redux/services/sessionServices'
import AfspHeader from '../AfspHeader';
import AfspFooter from '../AfspFooter';
import AfspPAS from '../AfspPAS';
import AfspPRA from '../AfspPRA';
import AfspLoginServices from '../../../redux/services/afspLoginServices';
import { ssFormServices, ssCommonUtils } from '@bit/ui-common.ui-components/ss-utils';
import { captcha } from '@bit/ui-common.ui-components/ss-common-data';

const
{ setEnvPrefix } = ssCommonUtils,
{ Header, Content, Footer } = Layout;

export default Container({ 
    services: [ 
        AfspLoginServices, 
        ssFormServices,
        captcha.captchaServices
    ]
},
class AfspLayout extends React.Component {
    state = { paths: {
        root: window.location.pathname,
        pra: '/pra',
        pas: '/pas'
    }}

    constructor(props) {
        super(props);
        this.props.services.logout = SessionServices.logout;
    }

    componentDidMount = () => this.setState({...this.state, view: this.props.children });

    getContent() {
        const
        { paths } = this.state,
        { children } = this.props;
        switch(window.location.pathname) {
            case paths.root:
                return children;
            case paths.pra:
                return (<AfspPRA />);
            case paths.pas:
                return (<AfspPAS />);
        }
    }

    getArgs() {
        const
        { props, state } = this,
        { paths } = state,
        { children, controlType, images, services } = props;
        
        let
        backgroundImage = null,
        background = '#FFFFFF',
        args = { header: {}, footer: {} },
        size = props.hasOwnProperty('size') ? props.size : { header: 'md', footer: 'md'},
        contentStyle = getContentStyle(size);

        args.header.state = this.props.state;
        args.header.services = services;
        args.header.paths = paths;
        args.header.size = size.header;
        args.footer.size = size.footer;

        // Check for 'bgc' (background color).
        if(this.props.hasOwnProperty('bgc')) background = this.props.bgc;
        else {
            if(NODE_ENV === 'DEVELOPMENT')
                cwrite('warning', 'AfspLayout.js -> render() :: this.props.bgc (String)')
                .msg('Unable to find \'bgc\', no background color used, will use default.');
        }

        // Set the background image for the Content component if available
        if(images != null && images.hasOwnProperty('backgroundImage')) contentStyle = {...contentStyle,
            backgroundImage: `url(${images.backgroundImage})`,
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover'
        } 
        else contentStyle = {...contentStyle, background };

        // Set the 'menu' components used to configure the 'user' controlType.
        if(props.hasOwnProperty('menu'))
            args.header.menu = props.menu;

        // Check for 'images'.
        if(this.props.hasOwnProperty('images')) {
            args.header.images = this.props.images;
            // Check for 'images.usePathname'. If it is not found, create it and default to 'true'.
            if(!args.header.images.hasOwnProperty('usePathname'))
                args.header.images.usePathname = true;
        } else {
            if(NODE_ENV === 'DEVELOPMENT')
                cwrite('error', 'AfspLayout.js -> render() :: this.props.images (Object)')
                .msg('No \'images\' object was found. Please pass in images paths.');
        }

        for(var p1 in this.props)
            for(var p2 in args)
                if(p1 !== 'children' && p1 !== 'size')
                    args[p2][p1] = this.props[p1];

        if(!args.header.hasOwnProperty('controlType'))
            args.header.controlType = 'login';
        else {
            // If the 'controlType' that was passed in is defined as 'custom'
            // there needs to be a 'customComponent' declaration that is used
            // and will assign the view to whatever is defined in 'customComponent'.
            if(args.header.controlType === 'custom') args.header.custom = {
                component: this.props.customComponent
            };
        }

        // Overrides the 'controlType' if the pathname is a particular path.
        switch(window.location.pathname) {
            case paths.pra:
            case paths.pas:
                // Switch the control type to return to some path.
                // 'back' uses a back arrow
                args.header.controlType = 'custom';
                args.header.custom = { component: (
                    <Row>
                        <Col span={24} style={{ textAlign: 'right' }}>
                            <Link to={setEnvPrefix(paths.root)}>
                                <Button 
                                    size='small' 
                                    style={{ width: '160px', top: '-5px', borderRadius: '20px' }}
                                    onClick={() => this.setState({...this.state, view: this.getContent() })}
                                >
                                    <Icon type='left' />
                                    {' Back'}
                                </Button>
                            </Link>
                        </Col>
                    </Row>
                )}
                break;
            default:
                args.header.controlType =
                    (controlType != null && controlType !== '') 
                        ? controlType 
                        : 'login';
        }

        return {
            contentStyle,
            args,
            size
        };
    }

    render() {
        const { contentStyle, args, size } = this.getArgs();
        return (
            <div>
                <Layout>
                    <Header {...config.header.props} style={{...config.header.style[size.header]}}>
                        <AfspHeader {...args.header} />
                    </Header>
                    <Content {...config.content.props} style={{...contentStyle}}>
                        {this.getContent()}
                    </Content>
                    <Footer
                        {...config.footer.props}
                        style={{...config.footer.style[size.footer]}}
                        onClick={() => this.setState({...this.state, view: this.getContent() })}
                    >
                        <AfspFooter
                            {...args.footer}
                            paths={this.state.paths}
                        />
                    </Footer>
                </Layout>
            </div>
        );
    }
});
